import "./ChatExceptionBlock.css";
import { Button } from "@ui/Button.jsx";
import { MaterialSymbol } from "@ui/MaterialSymbol";
import { createSignal, Show } from "solid-js";

type Props = {
	title?: string;
	message: string;
	identifier?: string;
};

export const ChatExceptionBlock = (props: Props) => {
	const [detailsOpen, setDetailsOpen] = createSignal(false);

	return (
		<div class="exception">
			<div
				class="error-panel"
				classList={{ "details-open": detailsOpen() }}
			>
				<header>
					<h3>
						<MaterialSymbol symbol="error" color="error" class="inline" />
						{props.title ?? "Error"}
					</h3>
					<Button
						variant="text"
						class="show-details"
						symbol="keyboard_arrow_down"
						onClick={() => setDetailsOpen((open) => !open)}
					>
						Details
					</Button>
				</header>
				<section class="details-container">
					<div class="details">
						<p class="message">{props.message}</p>
						<Show when={props.identifier}>
							<p class="identifier">Error ID: {props.identifier}</p>
						</Show>
					</div>
				</section>
			</div>
		</div>
	);
};
